document.addEventListener('DOMContentLoaded', function () {
    const tabLinks = document.querySelectorAll('.tab-link');
    tabLinks.forEach(link => {
        link.addEventListener('click', function () {
            const container = this.closest('.product-tabs-container');
            const tabId = this.getAttribute('data-tab');

            container.querySelectorAll('.tab-link').forEach(l => l.classList.remove('active'));
            container.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));

            this.classList.add('active');
            const activeContent = document.getElementById(tabId);
            if (activeContent) {
                activeContent.classList.add('active');
            }
        });
    });

    const arWrapper = document.querySelector('.product-gallery__ar-wrapper');
    const carouselList = document.querySelector('.product-gallery__thumbnail-list');
    const allItems = Array.from(carouselList.querySelectorAll('.product-gallery__thumbnail'));
    const visibleCount = 4 ;
    let currentIndex = 0;
    function initCarousel() {
        const wrapperHeight = arWrapper.offsetHeight;
        const itemHeight = wrapperHeight / visibleCount;
        carouselList.style.maxHeight = wrapperHeight + 'px';
        if (allItems.length > visibleCount) {
            setupNavButtons(itemHeight, allItems.length);
        }
        return wrapperHeight;
    }
    function setupNavButtons(itemHeight, totalCount) {
        const btnUp = document.querySelector('.thumb-nav-btn.up');
        const btnDown = document.querySelector('.thumb-nav-btn.down');
        if (!btnUp || !btnDown) return;
        btnUp.onclick = () => {
            if (currentIndex > 0) {
                currentIndex--;
                carouselList.scrollTo({
                    top: currentIndex * itemHeight,
                    behavior: 'smooth'
                });
            }
        };

        btnDown.onclick = () => {
            if (currentIndex < totalCount - visibleCount) {
            currentIndex++;
            carouselList.scrollTo({
                top: currentIndex * itemHeight,
                behavior: 'smooth'
            });
            }
        };
    }

    initCarousel();

    // 响应式处理：如果窗口大小改变，重新计算
    window.addEventListener('resize', initCarousel);
});